import React, { useContext, useEffect } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import PropTypes from 'prop-types';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(
    currentRouteName,
    currentRouteComponent,
    serverPages,
  );

  useEffect(() => {
    document.title = 'The Home Depot';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.landing.path}
          element={<routes.landing.component />}
        />

        <Route path="/error" element={<Error />} />

        <Route element={<Error />} />
      </Routes>
    </>
  );
};
// App.whyDidYouRender = true;

App.propTypes = {};

App.defaultProps = {};
